import { render } from "./toasted-notification.vue?vue&type=template&id=7047945c"
import script from "./toasted-notification.vue?vue&type=script&lang=js"
export * from "./toasted-notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__